<template>
  <div v-if="!product.isArchived" class="b2b-buying-zone__price flex items-center heading--sm font-medium">
    <span v-if="price" id="priceRange">
      <span qaid="actual-price" class="actual-price" :class="{salePrice: price.displayPrice.isSale}">{{
        displayPrice
      }}</span>
      <span v-if="price.excludeTaxes" id="excludeTaxText" class="exclude-tax" v-html="bp('excludeTax')" />
    </span>
    <span v-if="price && price.displayPrice.oldPrice" qaid="original-price" class="text-secondary line-through ml-1">
      {{ price.displayPrice.oldPrice }}
    </span>

    <span v-if="b2b" class="ml-1 text-sm">
      <span :qaid="qaidValueRetail">{{ bp(!consumerFriendlyMode ? 'retailerCost' : 'suggestedRetail') }}</span>
    </span>

    <pdp-product-price-tooltip
      v-if="b2b"
      v-show="!consumerFriendlyMode"
      :base-properties="baseProperties"
      :price="price"
      @min-qty-change="updateMinQty"
    >
    </pdp-product-price-tooltip>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import get from 'lodash/get';
import PdpProductPriceTooltip from '@/components/containers/pdp/b2b/PdpProductPriceTooltip';

export default {
  name: 'PdpProductPrice',
  components: {PdpProductPriceTooltip},
  props: {
    product: {
      type: Object,
      required: true,
    },
    isVariantSelected: {
      type: Boolean,
      required: true,
    },
    retailer: {
      type: Object,
      default: () => ({}),
    },
    consumer: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode', 'b2b']),
    ...mapGetters('advancedOrdering', ['advancedOrderingMode']),

    displayPrice() {
      return get(this.price.displayPrice, this.advancedOrderingMode && this.b2b ? 'advancedValue' : 'value', '');
    },
    price() {
      if (!this.b2b) {
        return this.consumer;
      }
      return this.consumerFriendlyMode ? this.consumer : this.retailer;
    },
    qaidValueRetail() {
      return !this.consumerFriendlyMode ? 'retail.cost.text' : 'retail.suggested.text';
    },
  },
  methods: {
    updateMinQty(quantity) {
      this.$emit('min-qty-change', quantity);
    },
  },
};
</script>
